<template>
  <div v-if="show" class="suspension-screen">
    <header class="main_menu">
      <div id="menu-segundo">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div class="row">
                <div class="col-6 blc-menu">
                  <div class="logomenu">
                    <img src="/img/logo-naabsa.png" alt="Logo NAABSA">
                    <h1 style="margin: 0;z-index: -1; font-size: 0;">Marcasite Agência Digital</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div class="suspension-content-wrapper">
      <div class="container">
        <div class="suspension-content">
          <div class="suspension-icon">
            <i class="fas fa-user-slash"></i>
          </div>
          <h1 class="suspension-title">Access Suspended</h1>
          <p class="suspension-message">{{ data.message }}</p>
          
          <div class="suspension-actions">
            <button class="btn btn-primary" @click="logout">Logout</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuspensionScreen',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    logout() {
      localStorage.clear();
      window.location.href = '/login';
    }
  }
}
</script>

<style scoped>
.suspension-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #18191D;
  z-index: 9999;
  font-family: 'Montserrat', sans-serif;
}

.main_menu {
  background-color: #131519;
  padding: 20px 0;
  border-bottom: 1px solid #282c36;
  position: relative;
  z-index: 10000;
}

.logomenu img {
  height: 50px;
  width: auto;
}

.suspension-content-wrapper {
  height: calc(100vh - 100px);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 0;
}

.suspension-content {
  max-width: 500px;
  width: 90%;
  background: #282c36;
  border-radius: 15px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  border: 1px solid #131519;
  margin: 0 auto;
}

.suspension-icon {
  font-size: 3.5rem;
  color: #df0024;
  margin-bottom: 20px;
}

.suspension-title {
  color: #df0024;
  font-size: 2rem;
  margin-bottom: 20px;
  font-weight: 600;
  font-family: 'Oswald', sans-serif;
}

.suspension-message {
  font-size: 1.1rem;
  color: #ebebeb;
  margin-bottom: 30px;
  line-height: 1.5;
}

.suspension-details {
  margin-bottom: 20px;
  text-align: left;
  background: #131519;
  padding: 15px;
  border-radius: 8px;
  border-left: 4px solid #df0024;
}

.suspension-details h3 {
  color: #ebebeb;
  font-size: 1rem;
  margin-bottom: 8px;
  font-weight: 600;
  font-family: 'Oswald', sans-serif;
}

.suspension-details p {
  color: #ebebeb;
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.4;
}

.suspension-actions {
  margin-top: 30px;
}

.btn {
  padding: 12px 30px;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  text-decoration: none;
  display: inline-block;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  transition: all 0.3s ease;
}

.btn-primary {
  background-color: #123e76;
  color: #ffffff;
  border: 2px solid #123e76;
}

.btn-primary:hover {
  background-color: #0e2d5a;
  border-color: #0e2d5a;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(18, 62, 118, 0.3);
}

@media (max-width: 768px) {
  .suspension-content-wrapper {
    height: calc(100vh - 80px);
    padding: 0;
  }
  
  .suspension-content {
    margin: 0;
    padding: 25px;
    width: 95%;
    max-width: 100%;
  }
  
  .suspension-title {
    font-size: 1.8rem;
  }
  
  .suspension-icon {
    font-size: 3rem;
  }
  
  .suspension-message {
    font-size: 1rem;
  }
}
</style>
